import axios from 'axios';
import store from '../store';
import { authStatus } from '../action/Status';

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
});

axiosInstance.interceptors.request.use((req) => {
    const { auth } = store.getState();
    if (auth && auth.token) {
        req.headers.Authorization = `Bearer ${auth.token}`;
    }
    return req;
}, (error) => {
    return Promise.reject(error);
});

axiosInstance.interceptors.response.use((res) => {
    return res;
}, (error) => {
    if (error.response) {
        const { status } = error.response;
        if (status === 500) {
            // localStorage.clear(); 
        }
    }
    return Promise.reject(error);
});

export default axiosInstance;
